<ng-container class="height-100;">
  <div style="height: 100%; overflow-x: auto">
    <div class="task-header p-4 height-100">
      <kt-workflow-accordion
        [header]="true"
        [statusesList]="statusesList"
        (refreshWorkflowList)="getWorkflowListSorted($event)"
      ></kt-workflow-accordion>
      <ng-container *ngIf="!noDataAvailable">
        <div class="workflow-column body-list-column mt-0">
          <kt-workflow-accordion
            *ngFor="let row of workflowGrid"
            [workflow]="row"
            [users]="usersObj"
            [header]="false"
            [entities]="entitiesObj"
            [drugs]="drugsObj"
            [contacts]="contactsObj"
            [statusesList]="statusesList"
            (refreshWorkflowList)="refreshWorkflowList($event)"
          >
          </kt-workflow-accordion>
        </div>
      </ng-container>
      <div *ngIf="noDataAvailable" class="no-data-container">
        <p class="mb-0">
          You have not created any workflow. <br />
          Add your first workflow.
        </p>
      </div>
      <mat-paginator
        [pageSize]="size"
        [pageSizeOptions]="[10, 25, 50, 200]"
        [length]="totalCountOfWorkflows"
        (page)="loadPage($event)"
        [showFirstLastButtons]="true"
      ></mat-paginator>
    </div>
  </div>
</ng-container>
